/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2021-09-30 00:00:00
 *
 *******************************************************/
//@flow
import _ from 'lodash';
import React, { Component } from 'react';
import { InlineError, TextStyle } from '@shopify/polaris';
import { WithI18nProps } from '@shopify/react-i18n';
import { AsyncPaginate } from 'react-select-async-paginate';
import { selectStyle } from 'src/components/views/common/forms/render-select.style';
import { RenderLabelTooltip } from 'src/components/views/common/forms/render-label-tooltip';
import { components } from 'react-select';

import { optimizeImage } from 'src/helpers';
import noProductImage from 'src/assets/images/product/no-product-image.png';

import RenderSelectProductWrapper from 'src/components/containers/merchandising-v2/rule/strategy/render-select-product-wrapper';
type State = {
  clearCache: boolean
};

type ComposedProps = WrapperComponentPropsType & WithI18nProps;
class RenderSelectProductPin extends Component<ComposedProps, State> {
  state = {
    clearCache: true
  };

  componentWillUnmount() {
    this.setState({ clearCache: true });
  }

  render() {
    const {
      input,
      meta = {},
      label,
      tooltip,
      isDisabled,
      textHelper,
      i18n,
      placeholder,
      loadOptions
    } = this.props;
    const { clearCache } = this.state;

    const hasError = !!meta.error && !!meta.touched;

    const Option = props => {
      let { images, id } = props.data;
      let image = _.isEmpty(images) ? '' : images[Object.keys(images)[0]];
      image = _.isEmpty(image) ? noProductImage : optimizeImage(image, '28x28');
      return (
        <div className="BC-Select_Option-Product  BC-Select_Merchandising-Attribute">
          <components.Option {...props}>
            <div className="product-image">
              <img src={image} alt={props.label} />
            </div>
            <div className="product-detail">
              <label>{props.label} </label>
              <p>{id}</p>
            </div>
          </components.Option>
        </div>
      );
    };

    const SingleValue = ({ children, ...props }) => {
      if (_.isEmpty(children)) return '';

      const { images } = props.data;
      let image = _.isEmpty(images) ? '' : images[Object.keys(images)[0]];
      image = _.isEmpty(image) ? noProductImage : optimizeImage(image, '20x20');
      return (
        <div className="BC-Select_SingleValue-Product">
          <components.SingleValue {...props}>
            <div className="product-image">
              <img src={image} alt={props.label} />
            </div>
            <label>{children}</label>
          </components.SingleValue>
        </div>
      );
    };

    const updatedStyle = {
      ...selectStyle,
      clearIndicator: (provided, state) => ({ ...provided, display: 'flex', padding: '7px 8px' }),
      option: (provided, state) => ({ ...provided, padding: '3px 12px' }),
      menu: (provided, state) => ({ ...provided, zIndex: 600, minWidth: '300px', right: 0 })
    };

    return (
      <div className={hasError ? 'Polaris-TextField--error' : ''}>
        <RenderLabelTooltip label={label} tooltip={tooltip} />
        <AsyncPaginate
          id={input.name}
          value={input.value}
          isClearable
          loadOptions={loadOptions}
          onChange={value => {
            input.onChange(value);
          }}
          label={label}
          styles={updatedStyle}
          placeholder={placeholder}
          maxMenuHeight={150}
          menuPortalTarget={document.body}
          classNamePrefix="BC-Select"
          isDisabled={isDisabled ? true : false}
          noOptionsMessage={() => i18n.translate('AdminHTML.Common.Empty.reactSelect_NoOptions')}
          components={{ Option, SingleValue }}
          onFocus={() => {
            this.setState({
              clearCache: !clearCache
            });
          }}
          cacheUniqs={[clearCache]}
        />

        {textHelper ? (
          <p style={{ marginTop: '0.25rem' }}>
            <TextStyle variation="subdued">{textHelper}</TextStyle>
          </p>
        ) : (
          ''
        )}
        {meta.error ? <InlineError message={meta.error} /> : ''}
      </div>
    );
  }
}

export default RenderSelectProductWrapper(RenderSelectProductPin);
